const LOADING_TYPES = {
  SIGN_IN: 'Signing in...',
  SAVE_EVENT: 'Saving event...',
  SAVE_PDF_REPORT: 'Saving PDF report...',
  SAVE_REPORT: 'Saving report...',
  APPEND_STUDY_LOG: 'Appending study log...',
  CLOSE_EVENT: 'Closing event...',
  GENERATE_EVENT_REPORT: 'Generating event report...',
  GENERATE_NOTIFICATION_REPORT: 'Generating notification report...',
  GENERATE_SUMMARY_REPORT: 'Generating summary report...',
  CREATE_STUDY: 'Creating new study...',
  UPLOADING_REPORT: 'Uploading report...',
  LOADING: 'Loading...',
  DOWNLOADING: 'Downloading...',
  SIGNING_OUT: 'Signing out...',
  SUBMITTING: 'Submitting...',
  SAVING: 'Saving...',
  COPYING_STUDY: 'Copying study...',
  REGENERATE_REPORT: 'Re-Generating report...',
  MARK_REPORT_AS_ARTIFACT: 'Marking report...',
  UNMARK_REPORT_AS_ARTIFACT: 'Unmarking report...',
  VIEW_ECG: 'Viewing ECG...',
  VIEW_REPORT: 'Viewing report...',
};

export default LOADING_TYPES;
